export default __webpack_public_path__ + "static/media/notification_sound.e50bc067.mp3";